(function($) {
    class W4D_CheckoutTabs {
        constructor() {
            this.initSelectors();
            this.bindEvents();
            this.checkValidation();
        }

        initSelectors() {
            // Main containers
            this.tabContentsWrapper = $('.js-checkout-tabs-content-wrapper');
            this.orderSummary = $('.woocommerce .order-summary');
            this.orderSummaryID = $('#order-summary');
            this.orderSummaryOverlay = $('.order-summary-overlay');

            // Navigation and tabs
            this.checkoutTabLinks = $('.checkout-tabs__nav a');
            this.cartDetailsContainer = $('.js-cart-details');

            // Buttons
            this.buttons = {
                cartToggle: $('.js-toggle-cart-details'),
                summaryToggle: $('.js-toggle-summary'),
                summaryClose: $('.js-close-summary'),
                nextStep: $('.next-step-btns-wrapper .btn--action'),
                editCustomer: $('.js-edit-customer-data'),
                editDelivery: $('.js-edit-delivery'),
                editPayment: $('.js-edit-payment'),
                removeCouopn: $('.remove_coupon')
            };

            // Add new selectors for billing fields
            this.billingFields = {
                billing_company: $('input[name="billing_company"]'),
                billing_oib: $('input[name="billing_oib"]'),
                firstName: $('input[name="billing_first_name"]'),
                lastName: $('input[name="billing_last_name"]'),
                address1: $('input[name="billing_address_1"]'),
                address2: $('input[name="billing_address_2"]'),
                city: $('input[name="billing_city"]'),
                postcode: $('input[name="billing_postcode"]'),
                phone: $('input[name="billing_phone"]'),
                email: $('input[name="billing_email"]')
            };

            this.toggleR1 = $('#toggle_r1');

            this.deliverySummaryContainer = $('.checkout__delivery .checkout__delivery__summary').eq(0);
            this.paymentSummaryContainer = $('.checkout__delivery .checkout__delivery__summary').eq(1);

            // Add selector for the customer data summary container
            this.customerDataSummary = $('.checkout__delivery__field-wrapper ul');

            // Ship To Different Address
            this.ship_to_different_aaddress_checkbox = $('#ship-to-different-address-checkbox');

            // Media query
            this.mediaQueryLg = window.matchMedia('(max-width: 1200px)');

            // Checkout privola checkbox
            this.checkout_privola_checkbox = $('#checkout_privola');

            // Checkout place order button
            this.place_order = $('#place_order')
        }

        bindEvents() {
            // Listen to blur events on form fields
            $('form.checkout').on('input blur', 'input, select, textarea', (e) => {
                this.checkValidation(e);
            });

            $('form.checkout').on('keypress',function(e) {
                if (e.which === 13) {
                    return false;
                }
            });
            $(document).on('click', '.remove_coupon', function(e) {
                e.preventDefault();
                window.remove_Coupon($(e.currentTarget));

            });
            // Tab navigation
            this.checkoutTabLinks.on('click', (e) => this.handleTabClick(e));

            // Cart and summary controls
            this.buttons.cartToggle.on('click', (e) => this.cartDetailsToggle(e));
            this.buttons.summaryToggle.on('click', (e) => this.toggleSummary(e));
            this.buttons.summaryClose.on('click', () => this.closeSummary());

            // Edit buttons
            this.buttons.editCustomer.on('click', (e) => this.handleEditClick(e, 0));
            this.buttons.editDelivery.on('click', (e) => this.handleEditClick(e, 1));
            this.buttons.editPayment.on('click', (e) => this.handleEditClick(e, 1));

            this.checkout_privola_checkbox.on('input', () => {
                if (this.checkout_privola_checkbox.prop('checked')) {
                    this.place_order.prop('disabled', false);
                } else {
                    this.place_order.prop('disabled', true);
                }
            });

            // This To Different Address
            this.ship_to_different_aaddress_checkbox.on('change', () => {
                this.checkValidation();
            });

            // Next step
            this.buttons.nextStep.on('click', (e) => this.handleNextStep(e));

            // Summary click handling

            /* zamjenjeno umjesto,
            this.orderSummary.on('click', (e) => e.stopPropagation());
              */
            this.orderSummary.on('click', function(e){

                if(!e.target.closest('.remove_coupon')){
                    e.stopPropagation();
                }
            })


            // Window events
            $(window).on('resize', () => this.closeSummary());
            $(document).on('click', () => this.handleDocumentClick());

            // Add media query listener
            this.mediaQueryLg.addEventListener('change', () => {
                this.closeSummary();
            });

            // Update Summary
            $(document).on('ajaxComplete', (event, xhr, settings) => {
                if (settings.url.indexOf('wc-ajax=update_order_review') !== -1) {
                    this.orderSummaryID.html(xhr.responseJSON.fragments.w4dOrderSummary);
                }
            });

            // Listen for shipping method changes
            $('input[name="shipping_method[0]"]').on('change', () => {
                if (this.checkoutTabLinks.eq(1).hasClass('active')) {
                    this.updateDeliverySummary();
                }
            });

            // Listen for payment method changes
            $('input[name="payment_method"]').on('change', () => {
                if (this.checkoutTabLinks.eq(1).hasClass('active')) {
                    $(document.body).trigger('update_checkout');
                    this.updatePaymentSummary();
                }
            });
        }

        updatePaymentSummary() {
            // Get the selected payment method
            const selectedPayment = $('input[name="payment_method"]:checked');

            // Get the payment method details
            const paymentWrapper = selectedPayment.closest('.radio-button-wrapper');
            const paymentName = paymentWrapper.find('h6').text();
            const paymentDescription = paymentWrapper.find('p').text();

            const paymentHTML = `
            <h6>${paymentName}</h6>
            <p>${paymentDescription}</p>`;

            this.paymentSummaryContainer.html(paymentHTML);
        }

        checkValidation() {
            const currentTab = this.checkoutTabLinks.filter('.active');
            const currentStepContent = this.tabContentsWrapper.children()
                .eq(currentTab.closest('li').index());

            let isValid = true;

            // Check all required fields in current step
            currentStepContent.find('.validate-required').each((index, element) => {
                const $field = $(element);

                // Skip shipping fields validation if checkbox is unchecked
                if ($field.closest('.woocommerce-shipping-fields__field-wrapper').length > 0
                    && !this.ship_to_different_aaddress_checkbox.is(':checked')) {
                    return true; // continue to next iteration
                }

                const $input = $field.find('input, select, textarea');

                // Check if it's an input field and it's empty
                if ($input.length && !$input.val().trim()) {
                    isValid = false;
                    return false; // break the loop
                }

                // Check if it's just an empty required paragraph
                if ($field.children().length === 0 || $field.text().trim() === '') {
                    isValid = false;
                    return false; // break the loop
                }
            });

            if ($(this.toggleR1).prop('checked')) {
                const { billing_company, billing_oib } = this.billingFields;

                [billing_company, billing_oib].forEach(field => {
                    const $wrapper = field.closest('p');
                    const fieldValue = field.val().trim();
                    const isFieldValid = fieldValue !== '';

                    if (!isFieldValid) {
                        $wrapper
                            .removeClass('woocommerce-validated')
                            .addClass('woocommerce-invalid');
                        isValid = false;
                    } else {
                        $wrapper
                            .removeClass('woocommerce-invalid')
                            .addClass('woocommerce-validated');
                    }
                });
            }

            /*if (this.checkout_privola_checkbox.length != 0 && !$(this.checkout_privola_checkbox).prop('checked')) {
                this.place_order.attr('disabled', true);
            } else {
                this.place_order.removeAttr('disabled');
            }*/
            

            // Toggle disabled class based on validation
            if (isValid) {
                this.buttons.nextStep.removeClass('btn--action-disabled');
            } else {
                this.buttons.nextStep.addClass('btn--action-disabled');
            }
        }

        handleNextStep(e) {
            e.preventDefault();

            if (this.buttons.nextStep.hasClass('btn--action-disabled')) {
                return false;
            }

            const currentTab = this.checkoutTabLinks.filter('.active');
            const nextTab = currentTab.closest('li').next().find('.js-checkout-tab-link');

            currentTab.addClass('checked');

            if (nextTab.length) {
                this.changeTab(nextTab);
            }
        }

        handleTabClick(e) {
            const $target = $(e.target);

            if ($target.hasClass('disabled-unchecked') || $target.hasClass('disabled')) {
                e.preventDefault();
                return false;
            }

            if ($target.hasClass('js-checkout-tab-link')) {
                this.tabTrigger(e);
            }
        }

        handleEditClick(e, tabIndex) {
            e.preventDefault();
            this.goToSpecificTab(tabIndex);
        }

        handleDocumentClick() {
            if (this.mediaQueryLg.matches && this.orderSummary.hasClass('active')) {
                this.closeSummary();
            }
        }

        goToSpecificTab(index) {
            const targetTab = this.checkoutTabLinks.eq(index);
            if (targetTab.length && !targetTab.hasClass('disabled-unchecked')) {
                this.changeTab(targetTab);
            }
        }

        changeTab($tabLink) {
            const index = $tabLink.closest('li').index();
            this.tabActiveNav($tabLink);
            this.showTabContent(index);

            if (index === 2) {
                this.updateCustomerPersonalDataSummary();
                this.updateDeliverySummary();
                this.updatePaymentSummary();
            }
        }

        updateDeliverySummary() {
            const selectedShipping = $('input[name="shipping_method[0]"]:checked');
            const shippingWrapper = selectedShipping.closest('.radio-button-wrapper');
            const shippingName = shippingWrapper.find('h6').text();
            const shippingPrice = shippingWrapper.find('[data-js-shipping-cost-display]').text();

            let deliveryHTML = `<h6>${shippingName}</h6>`;
            if(shippingPrice != undefined && shippingPrice != ''){
                deliveryHTML += `<p>${shippingPrice !== 'Besplatno' ? `Cijena dostave: ${shippingPrice}` : 'Besplatna dostava'}</p>`;
            }

            this.deliverySummaryContainer.html(deliveryHTML);
        }

        updateCustomerPersonalDataSummary() {
            const customerData = {
                billing_company: this.billingFields.billing_company.val(),
                billing_oib: this.billingFields.billing_oib.val(),
                name: `${this.billingFields.firstName.val()} ${this.billingFields.lastName.val()}`,
                email: this.billingFields.email.val(),
                address: this.formatAddress(),
                cityPostal: `${this.billingFields.postcode.val()} ${this.billingFields.city.val()}`
            };

            let summaryHTML = '';
            if($(this.toggleR1).length){
                if ($(this.toggleR1).prop('checked')) {
                    summaryHTML += `
                    <li><p>${customerData.billing_company}</p></li>
                    <li><p>${customerData.billing_oib}</p></li>`;
                }
                else{
                    this.billingFields.billing_company.val('');
                    this.billingFields.billing_oib.val('');
                }
            }
            else if(customerData.billing_company != undefined)
            {
                summaryHTML += `<li><p>${customerData.billing_company}</p></li>`;
            }

            summaryHTML += `
                <li><p>${customerData.name}</p></li>
                <li><p>${customerData.email}</p></li>
                <li><p>${customerData.address}</p></li>
                <li><p>${customerData.cityPostal}</p></li>`;

            this.customerDataSummary.html(summaryHTML);
        }


        formatAddress() {
            let address = this.billingFields.address1.val();
            const address2 = this.billingFields.address2.val();

            if (address2 && address2.trim() !== '') {
                address += ` ${address2}`;
            }

            return address;
        }

        showTabContent(index) {
            this.tabContentsWrapper.children().hide()
                .eq(index).show();
        }

        cartDetailsToggle(e) {
            this.cartDetailsContainer.toggleClass('hide');
            const $target = $(e.target);
            const text = this.cartDetailsContainer.hasClass('hide') ? 'Pokaži detalje' : 'Sakrij detalje';
            $target.text(text);
        }

        toggleSummary(e) {
            e.preventDefault();
            e.stopPropagation();

            if (this.mediaQueryLg.matches) {
                this.orderSummary.toggleClass('active');
                this.orderSummaryOverlay.toggleClass('active');
            } else {
                this.orderSummary.addClass('active');
                this.orderSummaryOverlay.removeClass('active');
            }
        }

        closeSummary() {
            this.orderSummary.removeClass('active');
            this.orderSummaryOverlay.removeClass('active');
        }

        tabTrigger(e) {
            e.preventDefault();
            const $el = $(e.target);
            this.changeTab($el);
        }

        tabActiveNav($el) {
            this.checkoutTabLinks.removeClass('active');
            $el.addClass('active')
                .removeClass('disabled-unchecked');

            if (!$el.hasClass('checked')) {
                $el.removeClass('checked');
            }
        }
    }

    $(document).ready(() => new W4D_CheckoutTabs());
})(jQuery);
